import { NewProcedure } from '../../../../api/Argentia/endpoints/procedures'
import { ApiProcedures } from '../../../../api/Argentia/endpoints/procedures/procedures.api'
import { AnnexedParameters, ProcedureStates } from '../../../../api/Argentia/enums'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../../../helpers/serviceResponseHelper'
import i18n from '../../../../i18n'
import { ActionIcons, DataTableActionConfiguration, DatePeriod } from '../../../../model'
import { ServiceResponse } from '../../../../model/serviceResponse'
import { getActiveBalanceZone, getActiveCompany } from '../../../../redux'
import {
  documentMapperForCancellation,
  mapperForCancellationAddProcedure,
  mapperForCancelProcedureGeneral
} from './comunicationProcedures.mapper'
import { ProcedureDocumentModel, ProcedureModel } from './comunicationProcedures.model'

const apiProcedures = new ApiProcedures()

export const fetchProceduresListItemsByDates = (
  datePeriod?: DatePeriod
): Promise<ServiceResponse<any>> => {
  return apiProcedures
    .FetchAll({
      datePeriod: datePeriod,
      company: getActiveCompany(),
      balanceZone: getActiveBalanceZone()
    })
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchProceduresListItemsByClient = (
  clientId: number
): Promise<ServiceResponse<any>> => {
  return apiProcedures
    .FetchAll({ clientId, company: getActiveCompany(), balanceZone: getActiveBalanceZone() })
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchProcedureItem = (
  idProcedure: number | undefined
): Promise<ServiceResponse<any>> => {
  return apiProcedures
    .Fetch(idProcedure)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchByCodOrigen = (
  idCups: number | undefined,
  codOrigen: string
): Promise<ServiceResponse<any>> => {
  return apiProcedures
    .FetchByCodOrigen(idCups, codOrigen)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

//#region Procedures global actions

export const filterApplicableActionsConfiguration = (
  item: ProcedureModel,
  configurations: Array<DataTableActionConfiguration>
): Array<DataTableActionConfiguration> => {
  let applicableActionsConfiguration: Array<DataTableActionConfiguration> = []
  configurations.forEach(configuration => {
    switch (configuration.icon) {
      case ActionIcons.ERROR: {
        if (item.state === ProcedureStates.Rechazado) {
          applicableActionsConfiguration.push(configuration)
        }
        break
      }
    }
  })

  return applicableActionsConfiguration
}

export const filterApplicableDocumentsActionsConfiguration = (
  item: ProcedureDocumentModel,
  configurations: Array<DataTableActionConfiguration>
): Array<DataTableActionConfiguration> => {
  let applicableActionsConfiguration: Array<DataTableActionConfiguration> = []
  configurations.forEach(configuration => {
    switch (configuration.icon) {
      case ActionIcons.ERROR: {
        if (item.parameters.findIndex(x => x.type === AnnexedParameters.DESCRIPCION_RECHAZO) > -1) {
          applicableActionsConfiguration.push({
            ...configuration,
            tooltip:
              item.parameters[
                item.parameters.findIndex(x => x.type === AnnexedParameters.DESCRIPCION_RECHAZO)
              ].value
          })
        }
        break
      }
    }
  })

  return applicableActionsConfiguration
}

export const getGlobalActionsConfiguration = (): Array<DataTableActionConfiguration> => {
  return [getErrorAction()]
}

const getErrorAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.ERROR,
    tooltip: i18n.t('comunicationProcedures:dataTable.tooltips.rejected')
  }
}

export const cancel = async (procedure: any): Promise<ServiceResponse<any>> => {
  return apiProcedures
    .Patch(procedure)
    .then(() => {
      return createSuccessServiceResponse(undefined)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const createProcedure = async (procedure: NewProcedure): Promise<ServiceResponse<any>> => {
  return await apiProcedures
    .Post(procedure)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const cancelProcedure = async (procedure: any): Promise<ServiceResponse<any>> => {
  return await apiProcedures
    .Post(mapperForCancellationAddProcedure(procedure))
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const cancelProcedureGeneral = async (
  procedure: any,
  type: AnnexedParameters,
  value: string
): Promise<ServiceResponse<any>> => {
  return await apiProcedures
    .Post(mapperForCancelProcedureGeneral(procedure, type, value))
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const closeProcedure = async (procedure: any): Promise<ServiceResponse<any>> => {
  return apiProcedures
    .PatchCloseProcedure(procedure.id, ProcedureStates.Cerrado)
    .then(() => {
      return createSuccessServiceResponse(undefined)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const saveDocumentProcedureForCancellation = async (
  procedure: any
): Promise<ServiceResponse<any>> => {
  return await apiProcedures
    .PostDocumentProcedure(procedure.id, documentMapperForCancellation(procedure))
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const saveDocumentProcedure = async (procedure: any): Promise<ServiceResponse<any>> => {
  return await apiProcedures
    .PostDocumentProcedure(procedure.idProcedure, procedure)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const saveProcedure = async (procedure: any): Promise<ServiceResponse<any>> => {
  return await apiProcedures
    .Post(mapperForCancellationAddProcedure(procedure))
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

//#endregion
